var map = {
	"./V1.jpg": 78,
	"./V2.jpg": 392,
	"./V3.jpg": 954,
	"./V4.jpg": 169,
	"./V5.jpg": 680,
	"./V6.jpg": 952,
	"./V7.jpg": 664,
	"./V8.jpg": 461,
	"./imageA.jpg": 721,
	"./imageB.jpg": 134,
	"./imageC.jpg": 354,
	"./imageD.jpg": 98,
	"./imageE.jpg": 911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;